export default function useSettings() {
  const { t } = useI18n()
  const localePath = useLocalePath()
  const route = useRoute()

  const settingsPages = computed<UVerticalNavigationLink[]>(() => {
    return [
      {
        active: route.path === localePath('settings'),
        icon: getIcon('dashboard'),
        label: t('navigation.settings.dashboard'),
        to: localePath('settings'),
      },
      {
        icon: getIcon('subscription'),
        label: t('navigation.settings.subscription'),
        to: localePath('settings-subscription'),
      },
      {
        icon: getIcon('team'),
        label: t('navigation.settings.team'),
        to: localePath('settings-team'),
      },
      {
        icon: getIcon('profile'),
        label: t('navigation.settings.profile'),
        to: localePath('settings-profile'),
      },
      {
        icon: getIcon('logout'),
        label: t('globals.signout'),
        to: localePath('auth-logout'),
      },
    ]
  })

  return { settingsPages }
}
